import classNames from "classnames";
import { ErrorFieldConfig } from "../types.d";

function ErrorField(props: ErrorFieldConfig) {
  return props.meta.touched && props.meta.error ? (
    <span className={classNames("form_error", props.additionalClassName)}>{props.meta.error}</span>
  ) : null;
}

export default ErrorField;
